import React, { useMemo } from 'react';
import PageHeader from 'components/common/general/layouts/PageHeader';
import { HelpButton } from 'components/common/census/HelpButton';
import { useHistory } from 'react-router-dom';
import { BasicCensusFlowLayout } from 'components/common/census/BasicCensusFlowLayout';
import useGroupQuoteUrlParams from 'global/hooks/useGroupQuoteUrlParams';
import CensusMonitorAddEePageStore, {
  CensusMonitorAddEePageStoreContext,
  useCensusMonitorAddEePageStoreContext,
} from 'store/pages/rfq/census-monitor-add-employees/pageStore';
import { NarrowPageWrapperStyled } from '../../../globalStyles';

/* TESTING_POLICY: CYPRESS_ONLY */

const PageContent: React.FC = () => {
  const pageStore = useCensusMonitorAddEePageStoreContext();
  return <BasicCensusFlowLayout pageStore={pageStore} />;
};

const CensusMonitorAddEeUploadPage: React.FC = () => {
  const history = useHistory();
  const { groupId, periodId, cartId } = useGroupQuoteUrlParams();

  function redirectBack(): void {
    history.push(`/monitor-add-employees/${periodId}?cartId=${cartId}&groupId=${groupId}`);
  }

  const pageStore = useMemo(
    () => new CensusMonitorAddEePageStore({ enrollmentPeriodId: periodId, groupId, cartId }),
    [],
  );

  return (
    <CensusMonitorAddEePageStoreContext.Provider value={pageStore}>
      <NarrowPageWrapperStyled>
        <PageHeader title="Census Import" onRedirect={redirectBack} subtitle={<HelpButton />} />
        <PageContent />
      </NarrowPageWrapperStyled>
    </CensusMonitorAddEePageStoreContext.Provider>
  );
};

export default CensusMonitorAddEeUploadPage;
